import script from "./PreviewPromptDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewPromptDialog.vue?vue&type=script&setup=true&lang=js"

import "./PreviewPromptDialog.vue?vue&type=style&index=0&id=fd9ed332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd9ed332"]])

export default __exports__